module.exports = __webpack_public_path__ + "media/favicon/mstile-150x150-e0fa0f85.png";